import React, { useState } from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import JsBarcode from "jsbarcode";
import { uiAlert } from "../../../../components/alerts/customAlert/uiAlert";

/* this initail template */
const ReceiptPDF = () => {
  const transaction = {
    transID: "TXN123456789",
    date: "2025-04-04T10:00:00Z",
    totalAmount: 30000,
    deliveryStatus: "SUPPLIED",
    paymentMode: "Cash",
    products: [
      { name: "Milk", quantity: 1, price: 2500 },
      { name: "Bread", quantity: 2, price: 1500 },
      { name: "Butter", quantity: 1, price: 3500 },
      { name: "Cheese", quantity: 1, price: 5000 },
    ],
  };

  const customer = {
    name: "Ebuka Malachi Eya",
    email: "eyauka@gmail.com",
    phone: "+45945447264",
    address: "Emma gads vej 12",
  };

  const generatePDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    // Add Title and Headers
    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.text("🛒 Urban Mart", 105, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Receipt No: #${transaction.transID}`, 10, 30);
    doc.text(`Date: ${new Date(transaction.date).toLocaleString()}`, 10, 38);

    // Customer Information
    doc.setFontSize(14);
    doc.text("Customer Information", 10, 50);
    doc.setFontSize(10);
    doc.text(`Name: ${customer.name}`, 10, 55);
    doc.text(`Email: ${customer.email}`, 10, 60);
    doc.text(`Phone: ${customer.phone}`, 10, 65);
    doc.text(`Address: ${customer.address}`, 10, 70);

    // Transaction Information
    doc.setFontSize(14);
    doc.text("Transaction Details", 10, 80);
    doc.setFontSize(10);
    doc.text(`Delivery Status: ${transaction.deliveryStatus}`, 10, 85);
    doc.text(`Payment Mode: ${transaction.paymentMode}`, 10, 90);
    doc.text(`Total Price: ₦${transaction.totalAmount.toLocaleString()}`, 10, 95);

    // Product Table
    autoTable(doc, {
      startY: 100,
      head: [["Item", "Quantity", "Price"]],
      body: transaction.products.map((item) => [item.name, item.quantity, `₦${item.price.toLocaleString()}`]),
      theme: "striped",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
      margin: { left: 10, right: 10 },
    });

    // Generate the PDF Blob
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head><title>Receipt Preview</title></head>
          <body style="margin:0">
            <embed src="${url}" type="application/pdf" width="100%" height="100%" />
          </body>
        </html>
      `);
      newWindow.document.close();
    } else {
      uiAlert("Popup blocked! Please allow popups for this site.", "error");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={generatePDF}
        style={{
          padding: "10px 20px",
          backgroundColor: "#2980b9",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Generate & Preview Receipt PDF
      </button>
    </div>
  );
};

export default ReceiptPDF;

/* import React from "react";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable"; */

export const InvoiceGenerator = () => {
  const generatePDF = () => {
    const doc = new jsPDF("p", "mm", "a4");

    const transaction = {
      transID: "TXN123456789",
      date: "2025-04-04T10:00:00Z",
      totalAmount: 30000,
      deliveryStatus: "SUPPLIED",
      paymentMode: "Cash",
      products: [
        { name: "Milk", quantity: 1, price: 2500 },
        { name: "Bread", quantity: 2, price: 1500 },
        { name: "Butter", quantity: 1, price: 3500 },
        { name: "Cheese", quantity: 1, price: 5000 },
      ],
    };

    const customer = {
      name: "Ebuka Malachi Eya",
      email: "eyauka@gmail.com",
      phone: "+45945447264",
      address: "Emma gads vej 12",
    };

    // Add Title and Headers
    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    doc.text("🛒 Urban Mart", 105, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text(`Receipt No: #${transaction.transID}`, 10, 30);
    doc.text(`Date: ${new Date(transaction.date).toLocaleString()}`, 10, 38);

    // Customer Information
    doc.setFontSize(14);
    doc.text("Customer Information", 10, 50);
    doc.setFontSize(10);
    doc.text(`Name: ${customer.name}`, 10, 55);
    doc.text(`Email: ${customer.email}`, 10, 60);
    doc.text(`Phone: ${customer.phone}`, 10, 65);
    doc.text(`Address: ${customer.address}`, 10, 70);

    // Transaction Information
    doc.setFontSize(14);
    doc.text("Transaction Details", 10, 80);
    doc.setFontSize(10);
    doc.text(`Delivery Status: ${transaction.deliveryStatus}`, 10, 85);
    doc.text(`Payment Mode: ${transaction.paymentMode}`, 10, 90);
    doc.text(`Total Price: ₦${transaction.totalAmount.toLocaleString()}`, 10, 95);

    // Product Table
    autoTable(doc, {
      startY: 100,
      head: [["ITEM", "QTY", "PRICE", "AMOUNT"]],
      body: transaction.products.map((item) => [
        item.name,
        item.quantity,
        `₦${item.price.toLocaleString()}`,
        `₦${(item.price * item.quantity).toLocaleString()}`,
      ]),
      theme: "striped",
      styles: { fontSize: 10 },
      headStyles: { fillColor: [41, 128, 185] },
      margin: { left: 10, right: 10 },
    });

    // Generate Barcode Image
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, transaction.transID, { format: "CODE128" });

    const barcodeDataUrl = canvas.toDataURL("image/png");
    doc.addImage(barcodeDataUrl, "PNG", 140, 180, 60, 20); // Position: (x, y), Size: (width, height)

    // Generate the PDF Blob
    const pdfBlob = doc.output("blob");
    const url = URL.createObjectURL(pdfBlob);

    // Open the PDF in a new tab
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <html>
          <head><title>Invoice Preview</title></head>
          <body style="margin:0">
            <embed src="${url}" type="application/pdf" width="100%" height="100%" />
          </body>
        </html>
      `);
      newWindow.document.close();
    } else {
      uiAlert("Popup blocked! Please allow popups for this site.", "error");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={generatePDF}
        style={{
          padding: "10px 20px",
          backgroundColor: "#2980b9",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "16px",
        }}
      >
        Generate Invoice PDF
      </button>
    </div>
  );
};
